(() => {
  let previousY = Math.max(0, window.scrollY);
  const announcementScroll = () => {
    const y = Math.max(0, window.scrollY), delta = y - previousY;
    if (Math.abs(delta) < 5 && y > 0) return;
    document.querySelectorAll('[data-announcement]').forEach(bar => {
      const wrapper = bar.closest('.shopify-section');
      if (!wrapper) return;
      const hide = y > bar.offsetHeight && delta > 0 && !wrapper.matches(':focus-within');
      wrapper.style.top = hide ? `-${bar.offsetHeight}px` : '0px';
    });
    previousY = y;
  };
  window.addEventListener('scroll', announcementScroll, {passive:true});
  document.addEventListener('focusin', event => {const bar=event.target.closest('[data-announcement]');if(bar)bar.closest('.shopify-section').style.top='0px';});
  const update = () => document.querySelectorAll('.ss-site-header').forEach(header => {
    header.classList.toggle('is-scrolled', window.scrollY > 24 && header.dataset.transparent === 'true');
  });
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  document.addEventListener('shopify:section:load', update);
  update();
  const languageObservers=new Map();
  const languageSlots=()=>{
    languageObservers.forEach((observer,slot)=>{if(!slot.isConnected){observer.disconnect();languageObservers.delete(slot);}});
    document.querySelectorAll('[data-ss-language-slot]').forEach(slot=>{
      if(languageObservers.has(slot))return;
      const sync=()=>{
        const locale=window._transtore?.languageCurrent?.locale;
        if(locale&&/^[a-z]{2,3}(?:[-_][a-z0-9]+)*$/i.test(locale))slot.style.setProperty('--ss-language-code',JSON.stringify(locale.split(/[-_]/)[0].toUpperCase()));
      };
      const observer=new MutationObserver(sync);observer.observe(slot,{childList:true,subtree:true,characterData:true});languageObservers.set(slot,observer);sync();
    });
  };
  languageSlots();document.addEventListener('shopify:section:load',languageSlots);document.addEventListener('shopify:section:unload',languageSlots);
  let activeDrawer, savedOverflow;
  // Transtore portals normally live under body, outside a modal dialog's top layer.
  // Move the original nodes (never clones) so its own controls remain interactive.
  const transtorePortals=new Map();
  const mountTranstorePortals=()=>{
    if(!activeDrawer?.querySelector('.ss-transtore-drawer'))return;
    document.querySelectorAll('body > .ts-dropdown-expand').forEach(node=>{
      const marker=document.createComment('Transtore portal');
      node.before(marker);transtorePortals.set(node,marker);activeDrawer.append(node);
    });
  };
  const portalObserver=new MutationObserver(mountTranstorePortals);
  const restoreTranstorePortals=()=>{
    portalObserver.disconnect();
    transtorePortals.forEach((marker,node)=>{node.classList.remove('ts-dropdown-expand__active');marker.replaceWith(node);});
    transtorePortals.clear();
  };
  const closeDrawer=()=>{
    if(!activeDrawer)return;
    const drawer=activeDrawer;if(drawer.classList.contains('is-closing'))return;
    drawer.classList.add('is-closing');
    setTimeout(()=>{restoreTranstorePortals();drawer.close();drawer.classList.remove('is-closing');activeDrawer=null;document.body.style.overflow=savedOverflow||'';
      document.querySelectorAll('[data-nav-open]').forEach(button=>button.setAttribute('aria-expanded','false'));
    },matchMedia('(prefers-reduced-motion:reduce)').matches?0:180);
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-nav-open]');
    if(button){
      const drawer=document.getElementById(button.dataset.navOpen);if(!drawer||drawer.open)return;
      savedOverflow=document.body.style.overflow;activeDrawer=drawer;document.body.style.overflow='hidden';
      drawer.showModal();button.setAttribute('aria-expanded','true');
      mountTranstorePortals();portalObserver.observe(document.body,{childList:true});
      drawer.oncancel=e=>{e.preventDefault();closeDrawer();};
      return;
    }
    if(activeDrawer){
      const r=activeDrawer.getBoundingClientRect();
      if(event.target.closest('[data-nav-close]')||event.target.closest('.ss-nav-drawer nav a')||(event.target===activeDrawer&&(event.clientX<r.left||event.clientX>r.right)))closeDrawer();
    }
  });
  window.addEventListener('resize',()=>{if(innerWidth>=1200)closeDrawer();},{passive:true});
  document.addEventListener('shopify:section:unload',()=>{if(activeDrawer)closeDrawer();});
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape'||activeDrawer)return;
    const open=[...document.querySelectorAll('.ss-site-header details[open]')].pop();
    if(open){open.open=false;open.querySelector('summary').focus();event.preventDefault();}
  });
  document.addEventListener('click',event=>{
    document.querySelectorAll('.ss-site-header details[open]').forEach(menu=>{
      if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;
    });
  });
  window.addEventListener('resize',()=>{if(innerWidth>=1200)document.querySelectorAll('.ss-mobile-menu[open]').forEach(menu=>menu.open=false);},{passive:true});
})();
